<template>
  <v-layout row wrap ma-0>
    <v-flex xs12>
      <p class="subtitle-2 mt-2 mb-2" v-show="valueKeysLength > 0">
        ปัจจัยที่เลือก
      </p>
    </v-flex>
    <v-flex xs12 class="d-flex align-content-start flex-wrap">
      <template v-for="key in valueKeys">
        <v-card
          :key="'options-' + key"
          outlined
          class="border-primary width-fit-content mr-2 mb-2"
          hover
        >
          <v-layout>
            <v-flex xs12 pa-2 class="d-flex flex-row">
              <div class="subtitle-1 primary--text mr-auto ml-3 title-line-height">
                {{ getOptionTitle(key) }}
              </div>
              <v-btn v-show="editable" icon color="primary ml-auto" @click="removeKey(key)">
                <v-icon small>clear</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <div class="d-flex flex-column px-5 py-2">
            <template v-if="getOptionType(key) === 'checkbox'">
              <template v-for="(choiceVal, choiceValIndex) in value[key]">
                <v-chip
                  :key="key + '-val-' + choiceValIndex"
                  :close="editable"
                  class="mr-auto mb-2"
                  @click:close="removeChoices(key, choiceValIndex)"
                >
                  {{ getChoicesName(key, choiceVal) }}</v-chip
                >
              </template>
            </template>
            <template v-if="getOptionType(key) === 'range'">
              <v-chip
                v-if="value[key][0] !== null"
                :close="editable"
                class="mr-auto mb-2"
                @click:close="removeRange(key, 0)"
              >
                {{ value[key][0] }}
                {{ getChoicesSuffix(key) }}</v-chip
              >
              <v-chip
                v-if="value[key][1] !== null"
                :close="editable"
                class="mr-auto mb-2"
                @click:close="removeRange(key, 1)"
              >
                ถึง {{ value[key][1] }} {{ getChoicesSuffix(key) }}</v-chip
              >
            </template>
            <template v-else-if="getOptionType(key) === 'number'">
              <v-chip
                :key="key + '-val'"
                :close="editable"
                class="mr-auto mb-2"
                @click:close="removeKey(key)"
              >
                {{ value[key] }} {{ getChoicesSuffix(key) }}</v-chip
              >
            </template>
          </div>
        </v-card>
      </template>
    </v-flex>
  </v-layout>
</template>

<script>
import cloneDeep from 'clone-deep';

export default {
  name: 'SelectedOptions',
  components: {},
  props: {
    value: {
      type: Object,
      default() {
        return {};
      }
    },
    dataSource: {
      type: Array,
      default() {
        return [];
      }
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({}),
  mounted() {},
  methods: {
    getOptionType(key) {
      const data = this.spreadDataSource.filter(x => x.name === key);

      if (Object.keys(data).length > 0) {
        return data[0].type;
      }
      return 'checkbox';
    },
    getChoicesSuffix(key) {
      const data = this.spreadDataSource.filter(x => x.name === key);

      if (Object.keys(data).length > 0) {
        return data[0].label;
      }
      return '';
    },
    getOptionTitle(key) {
      const data = this.spreadDataSource.filter(x => x.name === key);

      if (Object.keys(data).length > 0) {
        return data[0].title;
      }
      return '-';
    },
    getChoicesName(key, val) {
      const data = this.spreadDataSource.filter(x => x.name === key);
      if (Object.keys(data).length > 0) {
        const result = data[0].data.filter(x => x.id === val);
        if (result.length > 0) {
          return result[0].name;
        }
      }
      return '-';
    },
    removeKey(key) {
      const editedValue = cloneDeep(this.value);
      delete editedValue[key];
      this.saveValue(editedValue);
    },
    removeChoices(key, index) {
      const editedValue = cloneDeep(this.value);
      editedValue[key].splice(index, 1);
      if (editedValue[key].length === 0) {
        this.removeKey(key);
      } else {
        this.saveValue(editedValue);
      }
    },
    removeRange(key, index) {
      const editedValue = cloneDeep(this.value);
      editedValue[key][index] = null;
      if (editedValue[key].every(x => x === null)) {
        this.removeKey(key);
      } else {
        this.saveValue(editedValue);
      }
    },
    saveValue(val) {
      this.$emit('input', val);
    }
  },
  computed: {
    valueKeys() {
      return Object.keys(this.value);
    },
    valueKeysLength() {
      return this.valueKeys.length;
    },
    spreadDataSource() {
      const arr = [];
      this.dataSource.forEach(x => {
        arr.push(...x.options);
      });

      return arr;
    }
  }
};
</script>
<style lang="scss" scoped>
.title-line-height {
  line-height: 32px !important;
}
.border-primary {
  border-color: var(--v-primary-base) !important;
}
.width-fit-content {
  width: fit-content;
}
.hide-text {
  visibility: hidden;
}

::v-deep .v-chip.v-size--default {
  height: initial;
  min-height: 32px;
}
</style>
